export default __webpack_public_path__ + "static/wbs-logo-vertical-white-ol-e9e0d31e4fcf5d946040c2c53523a8dd.svg";